// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5756":"40c07e42","6483":"46c90b87"}[chunkId] + ".chunk.css";
};